// Pure helpers for the OAuth consent screen. No React or network here so the
// guard logic and scope mapping can be unit tested in isolation.

var SCOPE_LABEL_KEYS = {
  mcp: 'oauth:scopeMcp',
};

export function parseConsentParams(search) {
  var params = new URLSearchParams(search || '');
  return {
    requestId: params.get('request_id') || '',
    clientName: params.get('client_name') || '',
    scope: params.get('scope') || '',
  };
}

export function hasRequiredConsentParams(params) {
  return Boolean(params && params.requestId && params.clientName && params.scope);
}

export function getScopeLabelKey(scope) {
  if (scope && Object.prototype.hasOwnProperty.call(SCOPE_LABEL_KEYS, scope)) {
    return SCOPE_LABEL_KEYS[scope];
  }
  return null;
}
